<template>
  <div class="error">
    <img class="error__img error__section" src="@/assets/images/godzilla.png" />
    <div class="error__text">
      <h3 class="error__title error__section">
        {{ $t('publicNoServiceTitle') }}
      </h3>
      <h4 class="error__body error__section">
        {{ $t('publicNoServiceBody') }}
      </h4>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
@import '@/assets/scss/typography.scss';
.error {
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: $sp-40;

  &__img {
    height: 300px;
    @include mobile {
      height: 200px;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: $sp-16;
  }

  &__body {
    @extend %body-1;
    font-weight: 400;
  }

  &__section {
    align-self: center;
    text-align: center;
  }
}
</style>
